var exports = {};
export default exports;
/*eslint-disable*/
// https://github.com/component/ease/blob/master/index.js

// easing functions from "Tween.js"

exports.linear = function(n){
  return n;
};

exports.inQuad = function(n){
  return n * n;
};

exports.outQuad = function(n){
  return n * (2 - n);
};

exports.inOutQuad = function(n){
  n *= 2;
  if (n < 1) return 0.5 * n * n;
  return - 0.5 * (--n * (n - 2) - 1);
};

exports.inCube = function(n){
  return n * n * n;
};

exports.outCube = function(n){
  return --n * n * n + 1;
};

exports.inOutCube = function(n){
  n *= 2;
  if (n < 1) return 0.5 * n * n * n;
  return 0.5 * ((n -= 2 ) * n * n + 2);
};

exports.inQuart = function(n){
  return n * n * n * n;
};

exports.outQuart = function(n){
  return 1 - (--n * n * n * n);
};

exports.inOutQuart = function(n){
  n *= 2;
  if (n < 1) return 0.5 * n * n * n * n;
  return -0.5 * ((n -= 2) * n * n * n - 2);
};

exports.inQuint = function(n){
  return n * n * n * n * n;
}

exports.outQuint = function(n){
  return --n * n * n * n * n + 1;
}

exports.inOutQuint = function(n){
  n *= 2;
  if (n < 1) return 0.5 * n * n * n * n * n;
  return 0.5 * ((n -= 2) * n * n * n * n + 2);
};

exports.inSine = function(n){
  return 1 - Math.cos(n * Math.PI / 2 );
};

exports.outSine = function(n){
  return Math.sin(n * Math.PI / 2);
};

exports.inOutSine = function(n){
  return .5 * (1 - Math.cos(Math.PI * n));
};

exports.inExpo = function(n){
  return 0 == n ? 0 : Math.pow(1024, n - 1);
};

exports.outExpo = function(n){
  return 1 == n ? n : 1 - Math.pow(2, -10 * n);
};

exports.inOutExpo = function(n){
  if (0 == n) return 0;
  if (1 == n) return 1;
  if ((n *= 2) < 1) return .5 * Math.pow(1024, n - 1);
  return .5 * (-Math.pow(2, -10 * (n - 1)) + 2);
};

exports.inCirc = function(n){
  return 1 - Math.sqrt(1 - n * n);
};

exports.outCirc = function(n){
  return Math.sqrt(1 - (--n * n));
};

exports.inOutCirc = function(n){
  n *= 2
  if (n < 1) return -0.5 * (Math.sqrt(1 - n * n) - 1);
  return 0.5 * (Math.sqrt(1 - (n -= 2) * n) + 1);
};

exports.inBack = function(n){
  var s = 1.70158;
  return n * n * (( s + 1 ) * n - s);
};

exports.outBack = function(n){
  var s = 1.70158;
  return --n * n * ((s + 1) * n + s) + 1;
};

exports.inOutBack = function(n){
  var s = 1.70158 * 1.525;
  if ( ( n *= 2 ) < 1 ) return 0.5 * ( n * n * ( ( s + 1 ) * n - s ) );
  return 0.5 * ( ( n -= 2 ) * n * ( ( s + 1 ) * n + s ) + 2 );
};

exports.inBounce = function(n){
  return 1 - exports.outBounce(1 - n);
};

exports.outBounce = function(n){
  if ( n < ( 1 / 2.75 ) ) {
    return 7.5625 * n * n;
  } else if ( n < ( 2 / 2.75 ) ) {
    return 7.5625 * ( n -= ( 1.5 / 2.75 ) ) * n + 0.75;
  } else if ( n < ( 2.5 / 2.75 ) ) {
    return 7.5625 * ( n -= ( 2.25 / 2.75 ) ) * n + 0.9375;
  } else {
    return 7.5625 * ( n -= ( 2.625 / 2.75 ) ) * n + 0.984375;
  }
};

exports.inOutBounce = function(n){
  if (n < .5) return exports.inBounce(n * 2) * .5;
  return exports.outBounce(n * 2 - 1) * .5 + .5;
};

exports.inElastic = function(n){
  var s, a = 0.1, p = 0.4;
  if ( n === 0 ) return 0;
  if ( n === 1 ) return 1;
  if ( !a || a < 1 ) { a = 1; s = p / 4; }
  else s = p * Math.asin( 1 / a ) / ( 2 * Math.PI );
  return - ( a * Math.pow( 2, 10 * ( n -= 1 ) ) * Math.sin( ( n - s ) * ( 2 * Math.PI ) / p ) );
};

exports.outElastic = function(n){
  var s, a = 0.1, p = 0.4;
  if ( n === 0 ) return 0;
  if ( n === 1 ) return 1;
  if ( !a || a < 1 ) { a = 1; s = p / 4; }
  else s = p * Math.asin( 1 / a ) / ( 2 * Math.PI );
  return ( a * Math.pow( 2, - 10 * n) * Math.sin( ( n - s ) * ( 2 * Math.PI ) / p ) + 1 );
};

exports.outElasticTight = function(n){
  var s, a = 0.1, p = 0.8;
  if ( n === 0 ) return 0;
  if ( n === 1 ) return 1;
  if ( !a || a < 1 ) { a = 1; s = p / 4; }
  else s = p * Math.asin( 1 / a ) / ( 2 * Math.PI );
  return ( a * Math.pow( 2, - 10 * n) * Math.sin( ( n - s ) * ( 2 * Math.PI ) / p ) + 1 );
};

exports.inOutElastic = function(n){
  var s, a = 0.1, p = 0.4;
  if ( n === 0 ) return 0;
  if ( n === 1 ) return 1;
  if ( !a || a < 1 ) { a = 1; s = p / 4; }
  else s = p * Math.asin( 1 / a ) / ( 2 * Math.PI );
  if ( ( n *= 2 ) < 1 ) return - 0.5 * ( a * Math.pow( 2, 10 * ( n -= 1 ) ) * Math.sin( ( n - s ) * ( 2 * Math.PI ) / p ) );
  return a * Math.pow( 2, -10 * ( n -= 1 ) ) * Math.sin( ( n - s ) * ( 2 * Math.PI ) / p ) * 0.5 + 1;
};

// aliases

exports['in-quad'] = exports.inQuad;
exports['out-quad'] = exports.outQuad;
exports['in-out-quad'] = exports.inOutQuad;
exports['in-cube'] = exports.inCube;
exports['out-cube'] = exports.outCube;
exports['in-out-cube'] = exports.inOutCube;
exports['in-quart'] = exports.inQuart;
exports['out-quart'] = exports.outQuart;
exports['in-out-quart'] = exports.inOutQuart;
exports['in-quint'] = exports.inQuint;
exports['out-quint'] = exports.outQuint;
exports['in-out-quint'] = exports.inOutQuint;
exports['in-sine'] = exports.inSine;
exports['out-sine'] = exports.outSine;
exports['in-out-sine'] = exports.inOutSine;
exports['in-expo'] = exports.inExpo;
exports['out-expo'] = exports.outExpo;
exports['in-out-expo'] = exports.inOutExpo;
exports['in-circ'] = exports.inCirc;
exports['out-circ'] = exports.outCirc;
exports['in-out-circ'] = exports.inOutCirc;
exports['in-back'] = exports.inBack;
exports['out-back'] = exports.outBack;
exports['in-out-back'] = exports.inOutBack;
exports['in-bounce'] = exports.inBounce;
exports['out-bounce'] = exports.outBounce;
exports['in-out-bounce'] = exports.inOutBounce;
exports['in-elastic'] = exports.inElastic;
exports['out-elastic'] = exports.outElastic;
exports['in-out-elastic'] = exports.inOutElastic;

// easing functions from kent-lib

const kentLibEase = {
  linear: (i) => i,
  easeIn: (i) => i * i,
  easeOut: (i) => i * (2 - i),
  easeInOut: (i) => (i * i) / (1 + 2 * (i * i - i)),
  cubicIn: (i) => i * i * i,
  cubicOut: (i) => --i * i * i + 1,
  cubicInOut: (i) => {
    i *= 2;
    if (i < 1) return 0.5 * i * i * i;
    return 0.5 * ((i -= 2) * i * i + 2);
  },
  quadIn: (i) => i * i,
  quadOut: (i) => 1 - (1 - i) * (1 - i),
  quadInOut: (i) =>
    i < 0.5 ? 2 * i * i : 1 - Math.pow(-2 * i + 2, 2) / 2,
  quartIn: (i) => i * i * i * i,
  quartOut: (i) => 1 - --i * i * i * i,
  quartInOut: (i) => {
    i *= 2;
    if (i < 1) return 0.5 * i * i * i * i;
    return -0.5 * ((i -= 2) * i * i * i - 2);
  },
  quintIn: (i) => i * i * i * i * i,
  quintOut: (i) => --i * i * i * i * i + 1,
  quintInOut: (i) => {
    i *= 2;
    if (i < 1) return 0.5 * i * i * i * i * i;
    return 0.5 * ((i -= 2) * i * i * i * i + 2);
  },
  sineIn: (i) => 1 - Math.cos((i * Math.PI) / 2),
  sineOut: (i) => Math.sin((i * Math.PI) / 2),
  sineInOut: (i) => 0.5 * (1 - Math.cos(Math.PI * i)),
  exponentialIn: (i) => (0 == i ? 0 : Math.pow(1024, i - 1)),
  exponentialOut: (i) => (1 == i ? i : 1 - Math.pow(2, -10 * i)),
  exponentialInOut: (i) => {
    if (0 == i) return 0;
    if (1 == i) return 1;
    if ((i *= 2) < 1) return 0.5 * Math.pow(1024, i - 1);
    return 0.5 * (-Math.pow(2, -10 * (i - 1)) + 2);
  },
  circIn: (i) => 1 - Math.sqrt(1 - i * i),
  circOut: (i) => Math.sqrt(1 - --i * i),
  circInOut: (i) => {
    i *= 2;
    if (i < 1) return -0.5 * (Math.sqrt(1 - i * i) - 1);
    return 0.5 * (Math.sqrt(1 - (i -= 2) * i) + 1);
  },
  backIn: (i) => {
    let s = 1.70158;
    return i * i * ((s + 1) * i - s);
  },
  backOut: (i) => {
    let s = 1.70158;
    return --i * i * ((s + 1) * i + s) + 1;
  },
  backInOut: (i) => {
    let s = 1.70158 * 1.525;
    if ((i *= 2) < 1) return 0.5 * (i * i * ((s + 1) * i - s));
    return 0.5 * ((i -= 2) * i * ((s + 1) * i + s) + 2);
  },
  bounceIn: (i) => 1 - kentLibEase.bounceOut(1 - i),
  bounceOut: (i) => {
    if (i < 1 / 2.75) {
      return 7.5625 * i * i;
    } else if (i < 2 / 2.75) {
      return 7.5625 * (i -= 1.5 / 2.75) * i + 0.75;
    } else if (i < 2.5 / 2.75) {
      return 7.5625 * (i -= 2.25 / 2.75) * i + 0.9375;
    } else {
      return 7.5625 * (i -= 2.625 / 2.75) * i + 0.984375;
    }
  },
  bounceInOut: (i) =>
    i < 0.5
      ? kentLibEase.bounceIn(i * 2) * 0.5
      : kentLibEase.bounceOut(i * 2 - 1) * 0.5 + 0.5,
  elasticIn: (i) => kentLibEase.elasticIn_fn(i, 0.5, 0.1),
  elasticOut: (i) => kentLibEase.elasticOut_fn(i, 0.5, 0.1),
  elasticInOut: (i) => kentLibEase.elasticInOut_fn(i, 0.5, 0.1),
  wobbleIn: (i) => kentLibEase.elasticIn_fn(i, 0.2, 0.3),
  wobbleOut: (i) => kentLibEase.elasticOut_fn(i, 0.2, 0.3),
  wobbleInOut: (i) => kentLibEase.elasticInOut_fn(i, 0.2, 0.3),

  internal_elasticOutTight: (i) => elasticOut_fn(i, 0.8, 0.1),

  elasticIn_fn: (i, elasticity = 0.4, accel = 0.1) => {
    let s,
      a = accel,
      p = elasticity;
    if (i === 0) return 0;
    if (i === 1) return 1;
    if (!a || a < 1) {
      a = 1;
      s = p / 4;
    } else s = (p * Math.asin(1 / a)) / (2 * Math.PI);
    return -(
      a *
      Math.pow(2, 10 * (i -= 1)) *
      Math.sin(((i - s) * (2 * Math.PI)) / p)
    );
  },
  elasticOut_fn: (i, elasticity = 0.4, accel = 0.1) => {
    let s,
      a = accel,
      p = elasticity;
    if (i === 0) return 0;
    if (i === 1) return 1;
    if (!a || a < 1) {
      a = 1;
      s = p / 4;
    } else s = (p * Math.asin(1 / a)) / (2 * Math.PI);
    return (
      a * Math.pow(2, -10 * i) * Math.sin(((i - s) * (2 * Math.PI)) / p) + 1
    );
  },
  elasticInOut_fn: (i, elasticity = 0.4, accel = 0.1) => {
    let s,
      a = accel,
      p = elasticity;
    if (i === 0) return 0;
    if (i === 1) return 1;
    if (!a || a < 1) {
      a = 1;
      s = p / 4;
    } else s = (p * Math.asin(1 / a)) / (2 * Math.PI);
    if ((i *= 2) < 1)
      return (
        -0.5 *
        (a *
          Math.pow(2, 10 * (i -= 1)) *
          Math.sin(((i - s) * (2 * Math.PI)) / p))
      );
    return (
      a *
        Math.pow(2, -10 * (i -= 1)) *
        Math.sin(((i - s) * (2 * Math.PI)) / p) *
        0.5 +
      1
    );
  }
}

Object.assign(exports, kentLibEase);



// WEBPACK FOOTER //
// ./lib/pagehandler/anim/ease.js